import { Map, fromJS } from 'immutable';
import { ACCOUNT_STATUS, EMPTY_STRING } from '@constants/common';
import { ADD_DETAIL } from '@constants/actions';

const isBrowser = typeof window !== 'undefined';

const getInitialAccountInfo = () => {
  if (!isBrowser) return Map({});

  try {
    const savedUser = localStorage.getItem('USER_INFO');
    return savedUser ? fromJS(JSON.parse(savedUser)) : Map({});
  } catch (e) {
    return Map({});
  }
};

const getInitialStatus = () => {
  if (!isBrowser) return EMPTY_STRING;
  return localStorage.getItem('USER_INFO') ? ACCOUNT_STATUS.LOGGED_IN : EMPTY_STRING;
};

const initialState = Map({
  accountInfo: getInitialAccountInfo(),
  accountDetail: Map({}),
  status: getInitialStatus(),
});

const Account = (state = initialState, action) => {
  const actionPayload = fromJS(action.payload);
  switch (action.type) {
    case ACCOUNT_STATUS.LOGGED_IN:
      return state.set('accountInfo', actionPayload)
        .set('status', ACCOUNT_STATUS.LOGGED_IN);
    case ADD_DETAIL:
      return state.set('accountDetail', actionPayload);
    case ACCOUNT_STATUS.LOGGED_OUT:
      return initialState.set('accountInfo', Map({})).set('status', EMPTY_STRING);
    case ACCOUNT_STATUS.WRONG_CREDENTIALS:
      return state.set('status', ACCOUNT_STATUS.WRONG_CREDENTIALS);
    default:
      return state;
  }
};

export default Account;